


























import Vue from "vue";
import Component from "vue-class-component";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import { HeaderWidthItem, dateJp } from "@/types";

interface TableItem {
  sysId: number;
  id: string;
  name: string;
  office_name: string;
  medical_insurance: string;
  care_insurance: string;
  indicate: string;
  public_money: string;
  sex: string;
  birthday: string;
  address: string;
}

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class Receipt extends Vue {
  private yearmonth: string = dateJp(new Date()).substr(0, 7);
  private headerItems: HeaderWidthItem[] = [
    {
      value: "id",
      text: "利用者ID",
      width: "100px"
    },
    {
      value: "name",
      text: "氏名",
      width: "160px"
    },
    {
      value: "firigana",
      text: "フリガナ",
      width: "160px"
    },
    {
      value: "medical_insurance",
      text: "医療保険",
      width: "100px"
    },
    {
      value: "care_insurance",
      text: "介護保険",
      width: "100px"
    },
    {
      value: "public_money_medical",
      text: "医療公費",
      width: "100px"
    },
    {
      value: "public_money_care",
      text: "介護公費",
      width: "100px"
    },
    {
      value: "sex",
      text: "性別",
      width: "80px"
    },
    {
      value: "birthday",
      text: "生年月日",
      width: "180px"
    },
    {
      value: "address",
      text: "住所",
      width: "400px"
    }
  ];
  private tableItems: object[] = [
    {
      sysId: 1,
      id: "1",
      name: "田中太郎",
      firigana: "タナカタロウ",
      medical_insurance: "◯",
      care_insurance: "",
      indicate: "",
      public_money_care: "",
      public_money_medical: "",
      sex: "男",
      birthday: "1992年7月24日",
      address: "石川県金沢市小坂町中23-1"
    },
    {
      sysId: 2,
      id: "2",
      name: "田中花子",
      firigana: "タナカハナコ",
      medical_insurance: "",
      care_insurance: "◯",
      indicate: "◯",
      public_money_care: "◯",
      public_money_medical: "◯",
      sex: "女",
      birthday: "1992年8月24日",
      address: "石川県金沢市小坂町中23-1"
    },
    {
      sysId: 3,
      id: "3",
      name: "田中一郎",
      firigana: "タナカイチロウ",
      medical_insurance: "◯",
      care_insurance: "",
      indicate: "",
      public_money_care: "◯",
      public_money_medical: "",
      sex: "男",
      birthday: "1992年3月24日",
      address: "石川県金沢市小坂町中23-1"
    },
    {
      sysId: 4,
      id: "4",
      name: "田中次郎",
      firigana: "タナカジロウ",
      medical_insurance: "◯",
      care_insurance: "",
      indicate: "",
      public_money_care: "",
      public_money_medical: "",
      sex: "男",
      birthday: "1992年4月24日",
      address: "石川県金沢市小坂町中23-1"
    },
    {
      sysId: 5,
      id: "5",
      name: "田中三郎",
      firigana: "タナカサブロウ",
      medical_insurance: "◯",
      care_insurance: "",
      indicate: "",
      public_money_care: "",
      public_money_medical: "◯",
      sex: "男",
      birthday: "1992年5月24日",
      address: "石川県金沢市小坂町中23-1"
    },
    {
      sysId: 6,
      id: "6",
      name: "田中四郎",
      firigana: "タナカシロウ",
      medical_insurance: "",
      care_insurance: "",
      indicate: "",
      public_money_care: "◯",
      public_money_medical: "",
      sex: "男",
      birthday: "1992年6月24日",
      address: "石川県金沢市小坂町中23-1"
    }
  ];
}
